import { Component, Input, OnInit, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { UiHelper } from '@helpers/ui.helper';
//import { BarcodeFormat } from '@zxing/library';
import { ApiService } from '@services/api.service';
import { debounceTime, distinctUntilChanged, throttleTime } from 'rxjs/operators';

@Component({
  selector: 'ticket-scanner-component',
  templateUrl: '../../sharedTemplates/ticket.scanner.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./ticket.scanner.component.sass'],
})
export class TicketScannerComponent implements AfterViewInit {
  qrResultString: string;
  scanMessage = 'Scan QR Code or Barcode';

  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo = null;

  formatsEnabled = []; //: BarcodeFormat[] = [
  //   BarcodeFormat.CODE_128,
  //   BarcodeFormat.DATA_MATRIX,
  //   BarcodeFormat.EAN_13,
  //   BarcodeFormat.QR_CODE,
  //];

  hasDevices: boolean;
  hasPermission: boolean;

  torchEnabled = false;
  torchAvailable$ = new BehaviorSubject<boolean>(false);
  tryHarder = false;
  qrOpenerSubject = new Subject();

  constructor(private _router: Router, private route: ActivatedRoute, private _UiHelper: UiHelper, private _ApiService: ApiService) {
    this.qrOpenerSubject.pipe(throttleTime(2500)).subscribe((x: string) => {
      this.QRLogin(x.substring(3, x.length));
      setTimeout(() => {
        this.scanMessage = 'Scan QR Code or Barcode';
        // navigate home
        this._router.navigate(['/home']);
      }, 3000);
    });
  }

  ngAfterViewInit() {
    this._UiHelper.b3000SetRightMenuState('close');
  }

  getSlipDetail(SlipId) {
    this._router.navigate(['/scanner/slipDetail', SlipId]);
  }

  clearResult(): void {
    this.qrResultString = null;
  }

  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices;
    this.hasDevices = Boolean(devices && devices.length);
  }

  onCodeResult(resultString: string) {
    console.log('CODE', resultString);
    this.qrResultString = resultString;

    const BarCode = resultString;
    const firstCode = resultString.substring(0, 3);
    const BarcodeLength = BarCode.length;
    const PINStart = BarcodeLength - 3;
    const SLIPID = BarCode.substring(3, BarcodeLength - 3);

    if (firstCode == '100' || firstCode == '200' || firstCode == '500') {
      this.scanMessage = 'Slip detected...';
      setTimeout(() => {
        this.getSlipDetail(SLIPID);
      }, 500);
    } else if (resultString.startsWith('http')) {
      const _SLIP_ID = resultString.substring(resultString.lastIndexOf('/') + 1);
      setTimeout(() => {
        this.getSlipDetail(_SLIP_ID);
      }, 500);
    } else if (firstCode == 'b64') {
      let b64 = atob(BarCode.substring(3, BarcodeLength));

      let [_qr, _date] = b64.split('_');

      // check date if pass 5minutes
      let now = new Date();
      let qrDate = new Date(_date);
      let diff = now.getTime() - qrDate.getTime();
      let diffMinutes = Math.round(diff / 60000);

      if (diffMinutes > 5) {
        this.scanMessage = 'QR Code expired. Please try again.';
      } else {
        this.scanMessage = 'Login detected...';
        this.qrOpenerSubject.next(_qr);
      }
    } else {
      this.scanMessage = 'Invalid QR Code or Barcode';
    }
  }

  onDeviceSelectChange(selected: string) {
    const device = this.availableDevices.find(x => x.deviceId === selected);
    this.currentDevice = device || null;
  }

  onHasPermission(has: boolean) {
    this.hasPermission = has;
  }

  openInfoDialog() {
    const data = {
      hasDevices: this.hasDevices,
      hasPermission: this.hasPermission,
    };
    ////console.log("SCANNER_DATA--", data);
    //this._dialog.open(AppInfoDialogComponent, { data });
  }

  onTorchCompatible(isCompatible: boolean): void {
    this.torchAvailable$.next(isCompatible || false);
  }

  toggleTorch(): void {
    this.torchEnabled = !this.torchEnabled;
  }

  toggleTryHarder(): void {
    this.tryHarder = !this.tryHarder;
  }

  QRLogin(branchId) {
    this._ApiService.procCustomerQrCodeResult(branchId).then(x => {
      // Success
      if (x && x.resultcode === 104) {
        this.scanMessage = 'Login Successful. Opening Terminal...';
      } else {
        this.scanMessage = 'Login Failed. Please try again.';
      }
    });
  }
}
